export default "__VITE_ASSET__DaNGk7F0__"